import { useMutation } from '@tanstack/react-query'

import { GET_MEMBERS_QUERY } from '@/hooks/queries/use-get-members'
import { queryClient } from '@/services/query-client'
import { removeMember } from '@/services/remove-member'

export const useRemoveMember = () => {
  const mutation = useMutation({
    mutationFn: removeMember,
    onSuccess: () => queryClient.invalidateQueries([GET_MEMBERS_QUERY]),
  })

  return mutation
}
